import React from 'react'
import { LEGISLATION_KEY_PICKS } from 'constants/feature-flags'
import KeyPicks from 'components/shared/KeyPicks'
import SkeletonTiles from './SkeletonTiles'

const LegislationTiledMenuSkeleton = ({ windowHeight, headerHeight }) => (
  <div
    className='overflow-y-auto scrolling-container'
    style={{ maxHeight: `${windowHeight - headerHeight}px` }}
  >
    <div className='bg-ghost-grey pb9'>
      <div className='layout-width-constraint'>
        {LEGISLATION_KEY_PICKS && (
          <KeyPicks
            pending
            {...{
              className: 'pv8',
              iconName: 'icon-legislation',
              cxNames: {
                tile: {
                  borderColor: 'b--dark-orchid',
                  iconColor: 'cadet-blue',
                  onHover: 'legislation-tile'
                }
              }
            }}
          />
        )}
        <nav>
          <SkeletonTiles tileCount={18} />
        </nav>
      </div>
    </div>
  </div>
)

export default LegislationTiledMenuSkeleton
